import dynamic from "next/dynamic";

const DynamicUserGuideTooltip = dynamic(import("./userGuideTooltip"), {
  ssr: false,
});
// 静态导出
export { default as UserGuideTooltip } from "./userGuideTooltip";
// 动态导出
export default DynamicUserGuideTooltip;
